import { render } from "./GiftcardBoxAddon.vue?vue&type=template&id=b47e1d46"
import script from "./GiftcardBoxAddon.vue?vue&type=script&lang=js"
export * from "./GiftcardBoxAddon.vue?vue&type=script&lang=js"

import "./GiftcardBoxAddon.vue?vue&type=style&index=0&id=b47e1d46&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__